import { render, staticRenderFns } from "./IntegracoesModal.vue?vue&type=template&id=30f12dfd"
import script from "./IntegracoesModal.vue?vue&type=script&lang=js"
export * from "./IntegracoesModal.vue?vue&type=script&lang=js"
import style0 from "./IntegracoesModal.vue?vue&type=style&index=0&id=30f12dfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports